// schemas/productFormSchema.ts
import { z } from "zod";

export const productFormSchema = z.object({
  name: z.string().min(1, "Product name is required"),
  subtitle: z.string().min(1, "Subtitle is required"),
  category: z.string().min(1, "Category is required"),
  casNumber: z.string(),
  productDescription: z.string(),
  base64Image: z.string().min(1, "Image is required"),
  image: z.string().optional(), // Optional if you handle image upload separately
  productDetails: z.any(), // You can refine this based on your structure
  brochure: z.string().optional()
});

export type ProductFormData = z.infer<typeof productFormSchema>;
